import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Alert } from 'react-bootstrap';

import Empty from '../Layouts/Empty';
import { actionCreators } from '../actionCreators';
// import { Button } from '../UI/Button';

class LoginPage extends Component {
  constructor(props) {
    super(props);

    // declaring component state
    this.state = {
      email: '',
      password: '',
    };

    this.forgotPassword = this.forgotPassword.bind(this);
    this.updateFieldValueOnState = this.updateFieldValueOnState.bind(this);
    this.signIn = this.signIn.bind(this);
  }

  forgotPassword() {
    // console.log('Did you forgot password?');
  }

  signIn(ev) {
    ev.preventDefault();

    const { email, password } = this.state;
    this.props.dispatch(actionCreators.signIn(email, password));
  }

  updateFieldValueOnState(ev) {
    const { target: { name, value } } = ev;
    this.setState({ [name]: value });
  }

  render() {
    return (
      <Empty>
        <h1>Seja Bem-vindo!</h1>

        <form onSubmit={this.signIn}>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="text"
              name="email"
              className="form-control"
              value={this.state.email}
              onChange={this.updateFieldValueOnState}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Senha</label>
            <input
              type="password"
              name="password"
              className="form-control"
              value={this.state.password}
              onChange={this.updateFieldValueOnState}
            />
          </div>

          <div className="form-group form-group-button">
            <div className="form-group-button-description">
              <a
                onClick={this.forgotPassword}
                onKeyPress={this.forgotPassword}
                role="button"
                tabIndex="0"
              >
                Esqueceu a senha?
              </a>
            </div>

            <button type="submit" className="button button-primary button-right">
              Entrar
            </button>
          </div>
        </form>

        {this.props.errorMessage &&
          <Alert bsStyle="danger">
            {this.props.errorMessage}
          </Alert>
        }
        {/* <div className="form-description">
          <Button to="#" classes="button-block button-google">
            Login using Google+
          </Button>
          <Button to="#" classes="button-block button-facebook">
            Login using Facebook
          </Button>
        </div> */}
      </Empty>
    );
  }
}

LoginPage.defaultProps = {
  errorMessage: '',
};

LoginPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
};

const mapStateToProps = state => ({ errorMessage: state.authState.authError.message });
const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);



// WEBPACK FOOTER //
// ./src/Auth/LoginPage.js